/**
 * Cart Item Element
 *
 * Handles individual cart item interactions on the cart page
 * Communicates with the cart system via events
 *
 * Minimal HTML Usage:
 * <cart-item data-key="id:quantity">
 *  <button data-el="removeButton">Remove</button>
 * </cart-item>
 */

class CartItem extends window.MDLR.CustomElement {
  /**
   * Define required attributes for the cart item
   * data-key is required to identify the cart id/quantity
   */
  static get requiredAttributes() {
    return ["data-key"];
  }

  /**
   * Define required elements for the cart item
   * The remove button must have data-el="removeButton" attribute
   */
  static get requiredElements() {
    return ["removeButton"];
  }

  /**
   * Set up event listeners
   */
  setupListeners() {
    super.setupListeners();

    // Remove button click handler
    const removeButton = this.getElement("removeButton");
    this.listeners.add(removeButton, "click", this.#onRemoveClick.bind(this));
  }

  /**
   * Handle remove button click
   *
   * @private
   */
  async #onRemoveClick(event) {
    event.preventDefault();

    this.log("removing", "Removing item from cart...");

    const key = this.getAttribute("data-key");
    const removeButton = this.getElement("removeButton");

    if (!key) return;

    // Disable the button to prevent multiple clicks
    removeButton.disabled = true;
    removeButton.textContent = "Removing...";

    try {
      // Remove item with bundled section rendering
      // Section IDs are automatically pulled from sectionRenderer.cartSections
      await window.MDLR.Cart.removeItem(key);
    } catch (error) {
      this.log("error", "Error removing item from cart:", error);

      // Re-enable the button on error
      removeButton.disabled = false;
      removeButton.textContent = "Remove";
    }
  }
}

// Register the custom element
if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}
